import * as types from '../../configs/constants/actionType'
import generateActions from '../actions/actions'

const notificationReducer = (state: any = {}, action: any) => {
  switch (action.type) {
    case generateActions(types.NOTIFICATION_LIST).REQUEST:
      return Object.assign({}, state, { rows: [] }, { isLoading: true })
    case generateActions(types.NOTIFICATION_LIST).SUCCESS:
      return Object.assign({}, state, action.payload, { isLoading: false })
    case generateActions(types.NOTIFICATION_LIST).FAILURE:
      return Object.assign({}, state, action.payload, { isLoading: false, count: 0, rows: [] })
    case generateActions(types.ADD_NOTIFICATION).REQUEST:
      return Object.assign({}, state)
    case generateActions(types.ADD_NOTIFICATION).SUCCESS:
      return Object.assign({}, state, action.payload)
    case generateActions(types.ADD_NOTIFICATION).FAILURE:
      return Object.assign({}, state, action.payload)
    case generateActions(types.NOTIFICATION_DETAILS).REQUEST:
      return Object.assign({}, state, { notificationDetails: null }, { isLoading: true })
    case generateActions(types.NOTIFICATION_DETAILS).SUCCESS:
      return Object.assign({}, state, action.payload, { isLoading: false })
    case generateActions(types.NOTIFICATION_DETAILS).FAILURE:
      return Object.assign({}, state, action.payload, { isLoading: false })
    case generateActions(types.UPDATE_NOTIFICATION).REQUEST:
      return Object.assign({}, state)
    case generateActions(types.UPDATE_NOTIFICATION).SUCCESS:
      return Object.assign({}, state, action.payload)
    case generateActions(types.UPDATE_NOTIFICATION).FAILURE:
      return Object.assign({}, state, action.payload)
    case generateActions(types.UPDATE_NOTIFICATION_COUNTRY).REQUEST:
      return Object.assign({}, state)
    case generateActions(types.UPDATE_NOTIFICATION_COUNTRY).SUCCESS:
      return Object.assign({}, state, action.payload)
    case generateActions(types.UPDATE_NOTIFICATION_COUNTRY).FAILURE:
      return Object.assign({}, state, action.payload)
    case generateActions(types.DELETE_NOTIFICATION).REQUEST:
      return Object.assign({}, state)
    case generateActions(types.DELETE_NOTIFICATION).SUCCESS:
      return Object.assign({}, state, action.payload)
    case generateActions(types.DELETE_NOTIFICATION).FAILURE:
      return Object.assign({}, state, action.payload)
    case generateActions(types.CLEAR_ERROR).REQUEST:
      return Object.assign({}, state, { responseStatus: null })
    default:
      return state
  }
}

export default notificationReducer
